import { useQuery } from '@tanstack/react-query';
import useOpenApiClient from './useOpenApiClient';

export function useReceiptFile(fileId: string | undefined) {
  const { apiFetch } = useOpenApiClient();

  return useQuery({
    queryKey: ['v1', 'files', fileId],
    queryFn: () => {
      if (!fileId) {
        throw new Error('fileId is required');
      }
      return apiFetch.GET('/files/{file_id}', {
        params: {
          path: {
            file_id: `${fileId}`,
          },
        },
      });
    },
    select: (data) => data?.data?.data,
    enabled: Boolean(fileId),
  });
}
